import React, { useCallback, useRef } from 'react';
import { createContext } from '@shared/utils/createContext';
import type { TemplatePreviewOverridePayload } from '@shared/utils/previewMessageBus';

type TemplatePreviewStore = Readonly<{
  getActivePayload: () => TemplatePreviewOverridePayload | null;
  setActivePayload: (payload: TemplatePreviewOverridePayload | null) => void;
  // Once PreviewListener processes its first design message, it owns eventPreview.
  // The eventResponse→eventPreview sync in GuestSite.controller should stop.
  getHasPreviewListenerTakenOver: () => boolean;
  setHasPreviewListenerTakenOver: () => void;
}>;

const [TemplatePreviewContextProvider, useTemplatePreviewStore] = createContext<TemplatePreviewStore>({
  name: 'TemplatePreviewContext',
});

export { useTemplatePreviewStore };

export const TemplatePreviewProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const ref = useRef<TemplatePreviewOverridePayload | null>(null);
  const takenOverRef = useRef(false);
  const getActivePayload = useCallback(() => ref.current, []);
  const setActivePayload = useCallback((payload: TemplatePreviewOverridePayload | null) => {
    ref.current = payload;
  }, []);
  const getHasPreviewListenerTakenOver = useCallback(() => takenOverRef.current, []);
  const setHasPreviewListenerTakenOver = useCallback(() => {
    takenOverRef.current = true;
  }, []);
  const store = useRef({ getActivePayload, setActivePayload, getHasPreviewListenerTakenOver, setHasPreviewListenerTakenOver }).current;
  return <TemplatePreviewContextProvider value={store}>{children}</TemplatePreviewContextProvider>;
};
